<template>
  <div>
    <div
      v-if="loading"
      id="carregaDados"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div v-if="!text">
      <canvas
        id="myChart24"
        width="250"
        height="80"
      />
      <div
        v-if="exibirLegenda"
        id="legendadetalhereceberCR"
        class="text-center px-3"
      >
        <v-row
          align="center"
          class="ma-0"
          no-gutters
        >
          <v-col
            md="7"
            offset-md="3"
          >
            <v-row>
              <div
                v-for="status in colors"
                :key="status.statusExibicao"
              >
                <v-avatar
                  class="mr-1"
                  :color="status.corExibicao"
                  size="12"
                />
                <span class="mr-3 font-weight-light">{{ status.statusExibicao }}</span>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
    <div
      v-else
    >
      {{ text }}
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import ContasReceber from '../../../../../services/contasreceber'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardDetalhamentoReceber',
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      colors: [],
      myChart: {},
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      enableGrafico: true,
      text: null,
      empresa: [],
      selectClientes: [],
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      datasets: [],
      montaGrafico: true,
      loading: false,
      error: null,
      exibirLegenda: false,
    }),

    created () {
      eventEmit.$on('set-dados-detalhamento-contas-a-Receber', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-dados-detalhamento-contas-a-Receber', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.selectClientes = selectClientes

        this.MontarGrafico()
      },

      async MontarGrafico () {
        this.loading = true
        this.exibirLegenda = false

        if (this.myChart.data) {
          this.datasets = []

          this.myChart.destroy()
        }

        await ContasReceber.showDadosMovimentacaoAnual(this.primeiroDia, this.ultimoDia, this.empresa, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.colors = resposta.data.cores

            for (var i = 0; i < resposta.data.contasReceber.length; i++) {
              const dados = {
                label: resposta.data.contasReceber[i].categoria,
                backgroundColor: resposta.data.contasReceber[i].cor,
                order: i + 1,
                data: resposta.data.contasReceber[i].contasReceber,
              }

              this.datasets.push(dados)
            }

            const ctx = document.getElementById('myChart24').getContext('2d')
            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.datas,
                datasets: this.datasets,
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    stacked: true,
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem, data) => {
                      var i = tooltipItem[0].datasetIndex

                      tooltipItem[0].xLabel = data.datasets[i].label

                      return tooltipItem[0].xLabel
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há dados de movimentação de contas a receber no periodo selecionado') {
            this.text = resposta.data.mg

            this.error = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Não há datas de movimentação no periodo selecionado') {
            this.text = resposta.data.mg

            this.error = this.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {
    #myChart24 {
      width: 420px;
      height: 170px;
      margin: -2rem 0 0 -0.5rem;
    }

    #legendadetalhereceberCR {
      font-size: 10px;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #myChart24 {
      width: 420px;
      height: 170px;
      margin: -2rem 0 0 -0.5rem;
    }

    #legendadetalhereceberCR {
      font-size: 10px;
    }
  }
</style>

<style lang="sass">
  #legendadetalhereceberCR
    margin: 1rem 0 0 0

</style>
